// extracted by mini-css-extract-plugin
module.exports = {"main":"TimeLabel_main__3uHbx","size-small":"TimeLabel_size-small__2IbcO","size-medium":"TimeLabel_size-medium__2bpvH"};